// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"searchBar_searchBarContainer__MQin1"};